module.exports = __webpack_public_path__ + "img/img-sneakerverse.df697d61.png";